<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" elevation="1">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">{{
                  $t("category.title")
                }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="3" class="px-3">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  @input="sessionStorage(search)"
                ></v-text-field>
              </v-col>
              <v-col cols="auto">
                <v-btn class="primary" @click="addCategoryDialog = true">
                  <v-icon left> mdi-plus </v-icon>
                  Add Category
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="categories"
            :search="search"
          >
              <template v-slot:item.name="{ item }">
                <div class="text-truncate" style="max-width: 150px">
                  {{ item.name }}
                </div>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  color="secondary"
                  name="edit_category"
                  title="Edit Category"
                  style="margin-left: -10px"
                  @click="
                    addCategoryDialog = true;
                    category = { ...item };
                  "
                >
                  <img src="@/components/icons/edit-02.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="delete_expense"
                  title="Delete Expense"
                  @click="confirmDelete(item.id)"
                  v-if="!item.is_default"
                >
                  <img src="@/components/icons/delete-01.svg" width="18" height="18" />
                </v-btn>
              </template>
            </v-data-table>
        </v-card>
      </v-flex>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2"> Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteCategory">
              yes
            </v-btn>
            <v-btn color="primary" text @click="deleteDialog = false">
              No
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Add Category Dialog -->
      <v-dialog v-model="addCategoryDialog" max-width="450" persistent>
        <v-card>
          <v-card-title class="text-h5">
            {{ category.id ? "Edit" : "Add" }} Category
          </v-card-title>
          <v-card-text class="pa-5">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="category.name"
                  name="name"
                  id="name"
                  label="Name"
                  v-validate="'required'"
                  :error="
                    errors.first('name') != null ||
                      serverSideErrors.name != null
                  "
                  :error-messages="
                    errors.first('name') || serverSideErrors.name
                  "
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog">
              cancel
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              v-if="category.id"
              @click="updateCategory"
            >
              Update
            </v-btn>
            <v-btn color="blue darken-1" text @click="saveCategory" v-else>
              save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- End Category Add Dialog -->
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: `${this.$t("category.headers.name")}`,
          value: "name",
          width: "25%",
        },
        {
          text: `${this.$t("expense.headers.actions")}`,
          value: "actions",
          width: "15%",
          sortable: false,
          date: "",
        },
      ],
      addCategoryDialog: false,
      deleteDialog: false,
      categories: [],
      delete_id: "",
      category: {},
      serverSideErrors: {},
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getCategories() {
      let _self = this;

      _self.$axios
        .get("societyadmin/categories?recordsPerPage=99999999")
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.categories = data.categories;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    saveCategory() {
      let _self = this;

      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.$axios
            .post("societyadmin/categories", {
              name: this.category.name,
            })
            .then((response) => {
              let data = response.data;

              if (data.status) {
                _self.setAlert({
                  showAlert: true,
                  variant: "success accent-3",
                  timeout: "2000",
                  message: data.message,
                });

                _self.categories.unshift(data.category);

                _self.closeDialog();
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                }
              }
            });
        }
      });
    },
    updateCategory() {
      let _self = this;

      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.$axios
            .put(`societyadmin/categories/${this.category.id}`, {
              name: this.category.name,
            })
            .then((response) => {
              let data = response.data;

              if (data.status) {
                let index = this.categories.findIndex((category) => {
                  return category.id === this.category.id;
                });

                index != -1
                  ? Object.assign(this.categories[index], data.category)
                  : null;

                _self.setAlert({
                  showAlert: true,
                  variant: "success accent-3",
                  timeout: "2000",
                  message: data.message,
                });

                _self.closeDialog();
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                }
              }
            });
        }
      });
    },
    deleteCategory() {
      let _self = this;
      _self.$axios
        .delete(`societyadmin/categories/${this.delete_id}`)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            let index = this.categories.findIndex((category) => {
              return category.id == this.delete_id;
            });

            index != -1 ? this.categories.splice(index, 1) : null;

            this.delete_id = null;
            this.deleteDialog = false;

            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
    closeDialog() {
      this.$validator.reset();
      this.category = {};
      this.addCategoryDialog = false;
    },
  },
  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    this.getCategories();
  },
};
</script>
